<h1>Courses</h1>

<div *ngFor="let course of courses">
    <div><a routerLink="/home/admin/course/edit/{{course.id}}">{{course.title}}</a></div>
</div>
<router-outlet></router-outlet>
